<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<style lang="scss" module>
.container {
  @apply max-w-screen-sm overflow-hidden;
}

@screen sm {
  .container {
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.15);
    @apply rounded-md;
  }
}
</style>
